"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const _hoisted_1 = { "data-component": "dashboard" };
const _hoisted_2 = { class: "2xl:container mx-auto px-4 pt-7" };
const _hoisted_3 = { class: "grid grid-cols-1 md:grid-cols-5 xl:grid-cols-4 gap-y-px gap-x-0 md:gap-x-7" };
const _hoisted_4 = { class: "col-span-3" };
const _hoisted_5 = { class: "col-span-3" };
const _hoisted_6 = { class: "col-span-2 xl:col-span-1" };
const vue_3 = require("vue");
const BalanceCard_vue_1 = __importDefault(require("./BalanceCard.vue"));
const HighlightedNewsletters_vue_1 = __importDefault(require("./HighlightedNewsletters.vue"));
const News_vue_1 = __importDefault(require("./News.vue"));
const ShopMenu_vue_1 = __importDefault(require("./ShopMenu.vue"));
const securityStore_1 = require("../../stores/security/securityStore");
const PermissionEnum_1 = require("../../models/permission/PermissionEnum");
const Banner_vue_1 = __importDefault(require("../../components/Banner.vue"));
const BannerFile_1 = require("../../stores/banner/BannerFile");
exports.default = (0, vue_1.defineComponent)({
    __name: 'Dashboard',
    setup(__props) {
        const securityStore = (0, securityStore_1.useSecurityStore)();
        const currentUser = (0, vue_3.computed)(() => {
            return securityStore.authenticatedUser;
        });
        return (_ctx, _cache) => {
            var _a, _b, _c, _d, _e;
            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_1, [
                (0, vue_2.createVNode)(ShopMenu_vue_1.default),
                (0, vue_2.createElementVNode)("div", _hoisted_2, [
                    (0, vue_2.createElementVNode)("div", _hoisted_3, [
                        (0, vue_2.createElementVNode)("div", _hoisted_4, [
                            ((_a = (0, vue_2.unref)(currentUser)) === null || _a === void 0 ? void 0 : _a.hasPermission((0, vue_2.unref)(PermissionEnum_1.BannerPermissionEnum).BANNER_READ))
                                ? ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(Banner_vue_1.default, {
                                    key: 0,
                                    type: (0, vue_2.unref)(BannerFile_1.BannerFileTypeEnum).MAIN_PAGE
                                }, null, 8, ["type"]))
                                : (0, vue_2.createCommentVNode)("", true),
                            (0, vue_2.createElementVNode)("div", _hoisted_5, [
                                (((_b = (0, vue_2.unref)(currentUser)) === null || _b === void 0 ? void 0 : _b.hasPermission((0, vue_2.unref)(PermissionEnum_1.NewsPermissionEnum).NEWS_READ))
                                    && !((_c = (0, vue_2.unref)(currentUser)) === null || _c === void 0 ? void 0 : _c.hasPermission((0, vue_2.unref)(PermissionEnum_1.CustomerPermissionEnum).EXPORT_PARTNER)))
                                    ? ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(News_vue_1.default, { key: 0 }))
                                    : (0, vue_2.createCommentVNode)("", true)
                            ])
                        ]),
                        (0, vue_2.createElementVNode)("div", _hoisted_6, [
                            (0, vue_2.createVNode)(BalanceCard_vue_1.default),
                            ((_d = (0, vue_2.unref)(currentUser)) === null || _d === void 0 ? void 0 : _d.hasPermission((0, vue_2.unref)(PermissionEnum_1.BannerPermissionEnum).BANNER_READ))
                                ? ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(Banner_vue_1.default, {
                                    key: 0,
                                    type: (0, vue_2.unref)(BannerFile_1.BannerFileTypeEnum).UNIVERSAL
                                }, null, 8, ["type"]))
                                : (0, vue_2.createCommentVNode)("", true),
                            (!((_e = (0, vue_2.unref)(currentUser)) === null || _e === void 0 ? void 0 : _e.hasPermission((0, vue_2.unref)(PermissionEnum_1.CustomerPermissionEnum).EXPORT_PARTNER)))
                                ? ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(HighlightedNewsletters_vue_1.default, { key: 1 }))
                                : (0, vue_2.createCommentVNode)("", true)
                        ])
                    ])
                ])
            ]));
        };
    }
});
